import { render } from "./AssignToJobNotification.vue?vue&type=template&id=fd5213e2"
import script from "./AssignToJobNotification.vue?vue&type=script&lang=js"
export * from "./AssignToJobNotification.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__